import { Actions, createEffect, Effect, ofType } from "@ngrx/effects";
import { LoanApplicationService } from '../@core/data/service/loanapplication.service';
import { Injectable } from "@angular/core";
import {
  updateLoanApplication,
  loadLoanApplication,
  loadLoanApplicationError,
  loadLoanApplicationSuccess,
  updateLoanApplicationError,
  updateLoanApplicationSuccess,
  loadLoanApplicationById,
  loadLoanApplicationByIdError,
  createLoanApplication,
  createLoanApplicationSuccess,
  createLoanApplicationError,
  createLoanApplicationByXML,
  createLoanApplicationByXMLSuccess, createLoanApplicationByXMLError
} from './loanapplication.actions';
import { catchError, map, switchMap,exhaustMap, flatMap, withLatestFrom } from "rxjs/operators";


@Injectable()
export class LoanApplicationEffects {

  loadLoanApplication$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLoanApplication),
      exhaustMap(() =>
        this.loanApplicationService.getLoanApplication().pipe(
          map(loanApplications =>
            loadLoanApplicationSuccess({ loanApplications })
          ),
          catchError(() => [loadLoanApplicationError({ isError: true })])
        )
      )
    )
  );


  loadLoanApplicationById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLoanApplicationById),

      exhaustMap((action: any) =>

        this.loanApplicationService.getLoanAppFromList(action.id).pipe(
          map(loanApplication =>
            updateLoanApplicationSuccess({ loanApplication })
          ),
          catchError(() => [loadLoanApplicationByIdError()])
        )
      )
    )
  );


  updateLoanApplication$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateLoanApplication),
      exhaustMap(({ loanApplication }) =>
        this.loanApplicationService.updateItemInList(loanApplication).pipe(
          map(loanApplication =>
            updateLoanApplicationSuccess({ loanApplication })
          ),
          catchError(() => [updateLoanApplicationError()])
        )
      )
    )
  );
  createLoanApplication$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createLoanApplication),
      exhaustMap(({ loanApplication }) =>
        this.loanApplicationService.createLoanApplication(loanApplication).pipe(
          map(loanApplication =>
            createLoanApplicationSuccess({ loanApplication })
          ),
          catchError(() => [createLoanApplicationError()])
        )
      )
    )
  );
  createLoanApplicationByXML$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createLoanApplicationByXML),
      exhaustMap(({ loanApplication }) =>
        this.loanApplicationService.createLoanApplicationByXML(loanApplication).pipe(
          map(loanApplication =>
            createLoanApplicationByXMLSuccess({ loanApplication })
          ),
          catchError(() => [createLoanApplicationByXMLError()])
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private loanApplicationService: LoanApplicationService
  ) {}
}
